import React, { Component } from 'react'

export class PatientDetails extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default PatientDetails
